<template>
    <div class="fotersa">
      <div class="head-input">
        <a-form :layout="formLayout">
          <a-row :gutter="24" type="flex" justify="start">
            <a-col :span="6" class="fl2 fw">
              <a-form-item
                label="客户姓名"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
              <a-input
                placeholder="请输入客户姓名"
                v-model="form.custName"
                :allowClear="true"
              />
              </a-form-item>
            </a-col>
            <a-col :span="6" class="fl2 fw">
              <a-form-item
                label="患者姓名"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
              <a-input
                placeholder="请输入患者姓名"
                v-model="form.patName"
                :allowClear="true"
              />
              </a-form-item>
            </a-col>
            <a-col :span="6" class="fl2 fw">
              <a-form-item
                label="联系方式"
                :label-col="formItemLayout.labelCol"
                :wrapper-col="formItemLayout.wrapperCol"
              >
              <a-input
                placeholder="请输入联系方式"
                v-model="form.patPhoneNo"
                :allowClear="true"
              />
              </a-form-item>
            </a-col>
            <a-col :span="4" class="oper">
              <div style="height: 41px; line-height: 41px">
                <a-button class="btone" @click="searchList(1)">查询</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </div>
  
      
      <!-- 展示内容 -->
      <div class="base-content">
        <a-table
          :columns="columns"
          :rowKey="
            (record, index) => {
              return index;
              tableData;
            }
          "
          :data-source="tableData"
          :pagination="false"
          bordered
          size="small"
          :scroll="{ x: 1000, y: 'calc(100vh - 300px)' }"
        >
          <div slot="index" slot-scope="text, record, index">
            {{index + (pageNum-1) * pageSize + 1}}
          </div>
          <!-- 诊治阶段字典转换 -->
          <span slot="diaStage" slot-scope="text, record">
            {{ record.diaStage | DictionaryFilter("DIAG_STAGE") }}
          </span>
        </a-table>
        <!-- 分页 -->
        <div class="base-pagination">
          <div class="total-view">
            共{{ totalRows }}条数据，第{{ pageNum }}/{{ totalPages }}页
          </div>
          <div class="pagination-buttons">
            <a-pagination
              v-model="pageNum"
              :total="totalRows"
              :defaultPageSize="pageSize"
              show-less-items
              @change="changePageFn($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import {
    queryDiagnosis,
  } from "@/api/api.js";
  import { DictionaryService } from "@common/services/dictionary.service";
  import moment from "moment";
  moment.locale("zh-cn");

  export default {
    data() {
      return {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
        description: "", //图片描述
        imgStatus: undefined,  //图片状态
        tableData: [],  //表格数据
        form: {
          custName: "",
          patName: "",
          patPhoneNo: "",
          diaStage: "",
          diaRemark: "",
          surgeryTime: "",
        },
        //数列
        columns: [
          {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 48,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "客户姓名",
            align: "center",
            dataIndex: "custName",
            width: 110,
            scopedSlots: { customRender: "custName" },
          },
          {
            title: "患者姓名",
            dataIndex: "patName",
            align: "center",
            ellipsis: true,
            width: 110,
            scopedSlots: { customRender: "patName" },
          },
          {
            title: "患者联系方式",
            dataIndex: "patPhoneNo",
            align: "center",
            ellipsis: true,
            width: 130,
            scopedSlots: { customRender: "patPhoneNo" },
          },
          {
            title: "诊治阶段",
            dataIndex: "diaStage",
            align: "center",
            ellipsis: true,
            width: 250,
            scopedSlots: { customRender: "diaStage" },
          },
          {
            title: "手术时间",
            dataIndex: "surgeryTime",
            align: "center",
            ellipsis: true,
            width: 130,
            scopedSlots: { customRender: "surgeryTime" },
          },
          {
            title: "诊断说明",
            dataIndex: "diaRemark",
            align: "center",
            ellipsis: true,
            width: 230,
            scopedSlots: { customRender: "diaRemark" },
          },
        ],
        pageNum: 1,
        pageSize: 10,
        totalRows: 0,
        totalPages: 0,
        dictStatus: [],
        formLayout: "horizontal",
      };
    },
  
    activated() {
      DictionaryService.getAllNeedDic(["DIAG_STAGE"]).then((res) => {
        this.dictStatus = DictionaryService.getOptions("DIAG_STAGE");
        this.searchList(1);
      });
    },
    computed: {
      formItemLayout() {
        const { formLayout } = this;
        return formLayout === "horizontal"
          ? {
              labelCol: { span: 6 },
              wrapperCol: { span: 18 },
            }
          : {};
      },
    },
    methods: {
      //分页
      changePageFn(event) {
        this.pageNum = event;
        this.searchList();
      },
      //列表查询
      searchList(sum = 2) {
        if (sum == 1) this.pageNum = 1;
        let obj = {
          pageParam: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            orderBy: "",
          },
          content: {
            custName: this.form.custName,
            patName: this.form.patName,
            patPhoneNo: this.form.patPhoneNo,
          },
        };
          queryDiagnosis(obj).then((res) => {
              this.tableData = res.content.rows;
              this.totalRows = res.content.page.totalRows;
              this.totalPages = Math.ceil(this.totalRows / this.pageSize);
          }).catch((err) => {
              if (err.message) {
                this.$message.error(err.message);
              } else {
                this.$message.error("网络请求异常");
              }
            });
      },
    },
  };
  </script>
  <style lang="less" scoped="scoped">
  .base-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  /deep/.ant-table-body {
    margin-top: -8px !important;
  }
  .fotersa {
    width: 100%;
    height: 100%;
    .title-name {
      width: 100%;
      height: 46px;
      overflow: hidden;
      .sp_name {
        display: inline-block;
        font-size: 20px;
        margin: 0 0 20px 10px;
      }
    }
    .flex {
      display: flex;
      align-items: center;
    }
    .flex label {
      font-size: 16px;
      width: 73px;
    }
    .btone {
      margin-left: 10px;
    }
    .bttwo {
      margin-left: 10px;
    }
    /deep/.ant-table-thead {
      background-color: #dcf4ff;
    }
  
    a {
      margin-left: 10px;
    }
    a:hover {
      color: #70b9cf;
    }
  }
  /deep/.ant-form-item {
    margin-bottom: 0;
  }
  .title-name::before {
    content: "";
    width: 5px;
    height: 20px;
    display: inline-block;
    overflow: hidden;
    background-color: #0b2464;
  }
  /deep/ .ant-table-body {
    max-height: 487px;
    overflow: auto;
    margin: 0 !important;
  }
  /deep/.ant-table-tbody > tr > td {
    padding: 11px 16px;
  }
  
  /deep/ .form .ant-input,
  .ant-form-item-control,
  .ant-form-item-control-wrapper {
    width: 160px;
  }
  .fw {
    width: 236px;
  }
  .oper {
    width: 200px;
  }
  .ant-row {
  display: flex;
}
/deep/ .fl .ant-row .ant-col-6:nth-child(1) {
  width: 65px;
}
/deep/ .fl1 .ant-row .ant-col-6:nth-child(1) {
  width: 70px;
}
/deep/ .fl2 .ant-row .ant-col-6:nth-child(1) {
  width: 75px;
}
  /deep/ .ant-input-affix-wrapper {
    width: 160px;
  }
  /deep/ .ant-col-18 {
  width: 75%;
}
  </style>